import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import "./DashboardHome.css";

const data = [
  { month: "Jan", sales: 4000 },
  { month: "Feb", sales: 3000 },
  { month: "Mar", sales: 5000 },
  { month: "Apr", sales: 6500 },
  { month: "may", sales: 1500 },
  { month: "june", sales: 6000 },
];

const DashboardHome = () => {
  return (
    <div className="dashboard-home">
      <h2> Overview</h2>
      <div className="admin-stats">
        <div className="admin-stats">
          <div className="stat-card">
            <h3>120</h3>
            <p>Total Products</p>
          </div>
          <div className="stat-card">
            <h3>45</h3>
            <p>Pending Orders</p>
          </div>
          <div className="stat-card">
            <h3>320</h3>
            <p>Registered Users</p>
          </div>
          <div className="stat-card">
            <h3>₹ 75,000</h3>
            <p>Total Sales</p>
          </div>
        </div>
      </div>

      <div className="chart-container">
        <h3>Sales Overview</h3>
        <ResponsiveContainer width="100%" height={400}>
          <BarChart data={data}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="month" />
            <YAxis />
            <Tooltip />
            <Bar dataKey="sales" fill="#e6651b" barSize={50} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default DashboardHome;
